export const styles = (theme) => ({
  card: {
    marginTop: theme.spacing(4),
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: theme.palette.primary.main,
    borderRadius: 10,
    background: theme.palette.common.white,
    marginBottom: theme.spacing(3),
  },
  content: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    textTransform: 'uppercase',
  },
  errorBtn: {
    float: 'right',
  },
});
